import { jsonFetch } from "@/lib/helpers";
import { getCustomerPhoneUrl } from "./api-url.constants";
import { CustomerPhoneApiDTO } from "./dtos";

export const getCustomerPhone = async (userId?: string): Promise<string | undefined> => {
  const response = await jsonFetch<CustomerPhoneApiDTO>(getCustomerPhoneUrl(userId));
  return response.data.phone || undefined;
};
